import { render, staticRenderFns } from "./FinalOnHold.vue?vue&type=template&id=1334d48b&"
import script from "./FinalOnHold.vue?vue&type=script&lang=js&"
export * from "./FinalOnHold.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports